module.exports = __webpack_public_path__ + "img/0de03b5fb504a9e938caa3eabab53573.png";